<template>
    <component :is="layout"></component>
</template>
<script>
import MainLayout from "./components/commons/RomaLayoutMain";
import { mapGetters } from "vuex";
export default {
    components: { MainLayout },
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            layout: "getLayout",
        })
    }
};
</script>
<style lang="scss"></style>
